<template>
  <div id="new-device">
    <img src="@/assets/icons/ccmc.png" class="ccmc-icon">
    <img src="@/assets/icons/wilderverse.png" class="wilderverse-icon">

    <div class="notice">
      <p>CREATE YOUR OWN PATHFINDER</p>
      <p>DISCOVER NEW WORLDS</p>
    </div>

    <div class="buttons">
      <button id="start" class="button primary" @click="$router.push({ name: 'new' })">GET STARTED</button>
      <button
        id="find-existing"
        class="button secondary"
        @click="$router.push({name: 'find'})"
      >I ALREADY HAVE A PATHFINDER</button>
    </div>
  </div>
</template>

<script>
  export default {};
</script>

<style lang="scss">
  @import "@/assets/global.scss";
  #new-device {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    height: -moz-available; /* WebKit-based browsers will ignore this. */
    height: -webkit-fill-available; /* Mozilla-based browsers will ignore this. */
    height: fill-available;

    letter-spacing: 0.1em;

    .ccmc-icon {
      width: 45%;
    }

    .wilderverse-icon,
    .ccmc-icon {
      margin-top: 1em;
    }

    .notice {
      display: flex;
      flex-direction: column;
      align-content: center;
      align-items: center;
      justify-content: center;
      height: 30%;

      * {
        text-align: center;
        width: 85%;
      }

      :first-child {
        font-size: 1.25em;
        font-weight: bold;
        margin-bottom: 0.5em;
      }

      :nth-child(2) {
        font-size: 1em;
        text-shadow: 1px 1px 1px darken($color: $secondary, $amount: 10%);
      }
    }

    .buttons {
      display: flex;
      flex-direction: column;
      width: 90%;
      margin-top: auto;

      button {
        width: 100%;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 1.5em;
        height: 3.5em;
        font-size: 0.75em;
      }
    }

    @media only screen and (min-width: 600px) {
      .ccmc-icon {
        width: 25%;
      }

      .wilderverse-icon {
        height: 20%;
      }

      .notice {
        :first-child {
          font-size: 3em;
        }

        :nth-child(2) {
          font-size: 1em;
        }
      }

      .buttons {
        width: 75%;
        button {
          font-size: 2vw;
        }
      }
    }
  }
</style>
